module.exports = __webpack_public_path__ + "static/media/tr808_clave.8c16180e.wav";